import Base from "./base.js";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  COLLEGE_EVENT_INDEX,
  UPDATE_COLLEGE_EVENT,
  DELETE_COLLEGE_EVENT,
  CREATE_COLLEGE_EVENT,
  COLLEGE_EVENT_IMAGE
} from "@/utils/api-url";

class CollegeEventList extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"] || this._id || "";
    this.city = params["city"] || this.city || "";
    this.collegeId = params["collegeId"] || this.collegeId || "";
    this.collegeName = params["collegeName"] || this.collegeName || "";
    this.date = params["date"] || this.date || "";
    this.description = params["description"] || this.description || "";
    this.division = params["division"] || this.division || "";
    this.eventType = params["eventType"] || this.eventType || "";
    this.googleLocation = params["googleLocation"] || this.googleLocation || "";
    this.location = params["location"] || this.location || "";
    this.sponsor = params["sponsor"] || this.sponsor || "";
    this.state = params["state"] || this.state || "";
    this.teamA = params["teamA"] || this.teamA || "";
    this.teamB = params["teamB"] || this.teamB || "";
    this.time = params["time"] || this.time || "";
    this.title = params["title"] || this.title || "";
    this.views = params["views"] || this.views || "";
    this.displayOnProfile = params["displayOnProfile"]
      ? this.displayOnProfile
      : true;
  }

  static resourceName() {
    return "collegeEvent";
  }

  static index(params) {
    const profileId = this.profileId()
    return apiDispatcher(COLLEGE_EVENT_INDEX(params, profileId));
  }

  static create(params) {
    const { toSend } = params;
    return apiDispatcher(CREATE_COLLEGE_EVENT(toSend));
  }

  static update(params) {
    const { id, toSend } = params;
    return apiDispatcher(UPDATE_COLLEGE_EVENT(toSend, id));
  }

  static delete(params) {
    return apiDispatcher(DELETE_COLLEGE_EVENT(params, params.id));
  }

  static imageUpdate(params) {
    return apiDispatcher(COLLEGE_EVENT_IMAGE(params.image, params.id));
  }
}

export default CollegeEventList;
